import React,{useContext,useState} from 'react';
import normalizeMobile from "../../fns/normalizeMobile"
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {store} from "../../store"
import {socketio} from "../../components/Socket/AdminSocket"
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PhoneImage from "../../assets/img/call2.gif"

const CallUser = ({ tel,title }) => {
  const {state:{Auth:{profile}}} = useContext(store);
  let voipExtNumbers = [];
  if(profile?.operator?.voipExt) voipExtNumbers.push(profile.operator.voipExt)
  if(profile?.operator?.voipExt2) voipExtNumbers.push(profile.operator.voipExt2)
  if(!voipExtNumbers?.length) voipExtNumbers.push('110')
  const [open,setOpen] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickPhoneExt = (phoneExt)=>{
    socketio.emit('voipCall',{phoneNumber:tel,phoneExt});
    setOpen(true);
    setTimeout(()=>{setOpen(false)},3000);
    handleClose();
  }

  const handleCloseDialog = ()=>{
    setOpen(false);
  }
  
  return (
    <>
    <Dialog onClose={handleCloseDialog} open={open}>
      <DialogContent>
        <div style={{textAlign:'center'}}><img src={PhoneImage} height={40} width={40} /></div>
        <div style={{textAlign:'center'}}>گوشی داخلی خود را بر دارید:</div>
        <div style={{fontSize:10,color:'#ccc',width:200,margin:'0 auto',textAlign:'center'}}>پس از برداشتن گوشی، شماره مورد نظر شماره گیری خواهد شد.</div>
      </DialogContent>
    </Dialog>
      <a style={{cursor:'pointer'}} onClick={handleClick}>{title?title:normalizeMobile(tel)}</a>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {voipExtNumbers?.map(phoneExt=><MenuItem onClick={()=>handleClickPhoneExt(phoneExt)} key={`${tel}-${phoneExt}`}>{`تماس با داخلی: ${phoneExt}`}</MenuItem>)}
      </Menu>
    </>
  );
};

export default React.memo(CallUser);
